<!--==============================
=            PROJECTS            =
===============================-->

<template>
  <div>
    <v-row>
      <base-header>
        <div slot="page-header">Projects</div>
      </base-header>
    </v-row>
    <v-row>
      <v-col cols="12" md="4" sm="12" v-for="item in items" :key="item.title">
        <base-card>
          <div slot="card-header">

            <v-list-item dark>
            <v-card class="ml-n2 mr-3 elevation-2 card-light   rounded-lg ">
             <img style="width:50px;height:50px;padding:3px"
                     :src="require(`../../assets/images/logos/${item.img}.png`)">
             </v-card>
              <v-list-item-content>

                <v-list-item-title class="subtitle-1 font-weight-bold">
                  {{item.title}}
                </v-list-item-title>
                <v-list-item-subtitle>{{item.subtitle}}</v-list-item-subtitle>
              </v-list-item-content>


            </v-list-item>
          </div>
          <div slot="card-body">
      
              <v-row class="mt-n5 ">
                <v-col md="6">
                  <v-card class="pa-2 ml-3 transparent" flat  tile>
                    <v-avatar size="40" class="mr-n5">
                      <img src="../../assets/images/users/1.jpg" alt="John">
                    </v-avatar>
                    <v-avatar size="40" class="mr-n5">
                      <img src="../../assets/images/users/3.jpg" alt="John">
                    </v-avatar>
                    <v-avatar size="40" class="mr-n5">
                      <img src="../../assets/images/users/4.jpg" alt="John">
                    </v-avatar>
                    <v-avatar size="40" class="mr-n5">
                      <img src="../../assets/images/users/5.jpg" alt="John">
                    </v-avatar>

                    <v-avatar color="primary" dark class="mr-n5">
                      <v-icon dark>person_add_alt_1</v-icon>
                    </v-avatar>
                  </v-card>
                </v-col>

              </v-row>
              <v-chip-group v-model="selection" active-class="deep-purple accent-4 white--text" class="transparent ml-3" column>
                <v-chip label>Web Design</v-chip>

                <v-chip label>AI</v-chip>

                <v-chip label>2years</v-chip>

                <v-chip label>$$</v-chip>
              </v-chip-group>
             
           <v-card-actions class="pa-3">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>
                  <v-progress-linear value="100" height="10" striped color="green"></v-progress-linear>
                </v-list-item-title>
                <v-list-item-subtitle class="white--text" >
                100 % complet
                </v-list-item-subtitle>

              </v-list-item-content>
            </v-list-item>
          </v-card-actions>
          
          </div>
        </base-card>
      </v-col>
    



    </v-row>
  </div>

</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from '../../components/Base/BaseHeader'
  export default {
    components: {
      BaseCard,
      BaseHeader
    },
    data() {
      return {
        selection: 0,
        chip4: true,
        items: [{
          img: '12',
          title: 'AWS',
          color: 'error',
          status: 'pending',
          subtitle: 'Apple is Aliqua esse ipsum sint nulla Lorem aliquip aliqua duis non sit. Culpa deserunt proident elit eu officia. .',

        }, {
          img: '2',
          title: 'Arsona',
          color: 'success',
          status: 'complete',
          subtitle: 'AAliqua esse ipsum sint nulla Lorem aliquip aliqua duis non sit. Culpa deserunt proident elit eu officia. .',

        }, {
          img: '3',
          title: 'Web Site',
          color: 'success',
          status: 'complete',
          subtitle: ' proident elit eu officia. .',

        }, {
          img: '4',
          title: 'In',
          color: 'error',
          status: 'pending',
          subtitle: ' Culpa deserunt proident elit eu officia. .',

        }, {
          img: '5',
          title: 'Objective',
          color: 'error',
          status: 'pending',
          subtitle: ' Culpa deserunt proident elit eu officia. .',

        }, {
          img: '6',
          title: 'Quasae',
          color: 'error',
          status: 'pending',
          subtitle: 'Aliquip aliqua duis non sit. Culpa deserunt proident elit eu officia. .',

        }, {
          img: '7',
          title: 'Gitlab',
          color: 'error',
          status: 'pending',
          subtitle: ' Aliqua esse ipsum sint nulla Lorem aliquip aliqua duis non sit. Culpa deserunt proident elit eu officia. .',

        }, {
          img: '8',
          title: 'Google',
          color: 'success',
          status: 'complete',
          subtitle: ' is Aliqua esse ipsum sint nulla Lorem aliquip aliqua duis non sit. Culpa deserunt proident elit eu officia. .',

        }, {
          img: '9',
          title: 'Gov',
          color: 'error',
          status: 'pending',
          subtitle: ' is Aliqua esse ipsum sint nulla Lorem aliquip aliqua duis non sit. Culpa deserunt proident elit eu officia. .',

        }, ]
      }
    },

  }
</script>

<style scoped>
  .card-light {
    border-radius: 1em;
    border: 1px solid rgba(255, 255, 255, 0.5);
    text-shadow: 0 0 1em rgba(0, 0, 0, 0.5);
    background: rgba(255, 255, 255, 0.2);
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
    transform: perspective(500px);
    transform-style: preserve-3d;
  }
</style>

<!--====  End of PROJECTS  ====-->
